export const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const validatePhone = (value: unknown): boolean => {
  return PHONE_REGEX.test(value as string);
};
